module.exports = __webpack_public_path__ + "688e15f9df1da21ba5cae0ce63e31a08.jpg";